// jsonpUtil.js
export default {
  jsonp(url, params, callback) {
    return new Promise((resolve, reject) => {
      // 创建一个唯一的回调函数名称
      const callbackName =
        "jsonp_callback_" +
        Date.now() +
        "_" +
        Math.random().toString(36).substr(2, 9);

      // 将回调函数名称添加到参数中
      params.callback = callbackName;

      // 构建完整的URL
      const queryString = Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join("&");
      const fullUrl = `${url}?${queryString}`;

      // 创建一个script标签
      const script = document.createElement("script");
      script.src = fullUrl;

      // 定义全局回调函数
      window[callbackName] = (response) => {
        // 删除全局回调函数
        delete window[callbackName];
        // 移除script标签
        document.head.removeChild(script);

        // 检查响应是否有效
        if (typeof response === "object" && response !== null) {
          resolve(response);
        } else {
          reject(new Error("Invalid JSONP response"));
        }
      };

      // 监听脚本加载错误
      script.onerror = () => {
        delete window[callbackName];
        document.head.removeChild(script);
        reject(new Error("JSONP request failed"));
      };

      // 将script标签添加到DOM中
      document.head.appendChild(script);

      // 添加超时处理（可选）
      const timeout = setTimeout(() => {
        delete window[callbackName];
        document.head.removeChild(script);
        reject(new Error("JSONP request timed out"));
      }, 5000); // 5秒超时

      // 清理超时处理（如果请求成功）
      script.onload = () => {
        clearTimeout(timeout);
      };
    });
  },
};
